import { ref, watch, nextTick, computed } from "vue";
import { u as useI18n } from "./assets/index-CgZzOVq6.js";
import "vue-demi";
import { u as useDataTestIdProp } from "./assets/index-BNd8MWnO.js";
import "./assets/index-vzP2cezV.js";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import XButton from "./XButton.js";
import { X as XIcon } from "./assets/XIcon-U9bwokTN.js";
import { n as normalizeComponent } from "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
import "vue-i18n";
import "./locales.js";
import "./assets/index-Ca8wHgNc.js";
import "./assets/index-DKxr0Yto.js";
import "./assets/index-4vIud5LZ.js";
import "./assets/BaseLink-KuovKwoP.js";
import "./assets/index-D0Qy8ijJ.js";
import "./XSpinner.js";
import "@fortawesome/vue-fontawesome";
function useActions(options) {
  const { emit, props } = options;
  const isEditing = ref(false);
  async function handleEditorFocus() {
    var _a;
    if (props.editorSelectorToFocus && isEditing.value) {
      await nextTick();
      (_a = document.querySelector(props.editorSelectorToFocus)) == null ? void 0 : _a.focus();
    }
  }
  function toggleEditor() {
    isEditing.value = !isEditing.value;
    emit("edit", isEditing.value);
  }
  function handleEditor() {
    toggleEditor();
    handleEditorFocus();
  }
  function handleCancel() {
    emit("cancel");
    toggleEditor();
  }
  function handleSave() {
    emit("save");
    if (!props.asyncSave) toggleEditor();
  }
  watch(
    () => props.isSending,
    (newValue) => {
      if (!newValue && isEditing.value) toggleEditor();
    }
  );
  return {
    isEditing,
    handleEditor,
    handleCancel,
    handleSave
  };
}
const XInlineEdit$1 = "_XInlineEdit_mvj2d_1";
const label = "_label_mvj2d_12";
const container = "_container_mvj2d_20";
const data = "_data_mvj2d_26";
const content = "_content_mvj2d_30";
const editor = "_editor_mvj2d_36";
const actions = "_actions_mvj2d_42";
const actionsEditor = "_actionsEditor_mvj2d_45";
const style0 = {
  XInlineEdit: XInlineEdit$1,
  label,
  container,
  data,
  content,
  editor,
  actions,
  actionsEditor
};
const { createTestIdProp, setupTestId } = useDataTestIdProp();
const __default__ = {
  name: "XInlineEdit",
  components: { XButton, XIcon }
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    isMultiple: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    },
    inputId: {
      type: String,
      default: ""
    },
    editorSelectorToFocus: {
      type: String,
      default: ""
    },
    isInvalid: {
      type: Boolean,
      default: false
    },
    isSending: {
      type: Boolean,
      default: false
    },
    asyncSave: {
      type: Boolean,
      default: false
    },
    ...createTestIdProp()
  },
  emits: ["edit", "cancel", "save"],
  setup(__props, { emit }) {
    const props = __props;
    const { t } = useI18n();
    const { formatTestId } = setupTestId(props);
    const { isEditing, handleEditor, handleCancel, handleSave } = useActions({ props, emit });
    const buttonRadius = computed(() => props.isMultiple ? "rounded" : "circle");
    const buttonSize = computed(() => props.isMultiple ? "" : "sm");
    return { __sfc: true, createTestIdProp, setupTestId, props, emit, t, formatTestId, isEditing, handleEditor, handleCancel, handleSave, buttonRadius, buttonSize, XButton, XIcon };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { class: [_vm.$style.XInlineEdit, _vm.isMultiple && _vm.$style.isMultiple], attrs: { "aria-disabled": _vm.isSending, "data-testid": _setup.formatTestId() } }, [_vm.label && !_vm.isMultiple ? _c("label", { class: _vm.$style.label, attrs: { "for": _vm.inputId, "data-testid": _setup.formatTestId("label") } }, [_vm._v(" " + _vm._s(_vm.label) + " ")]) : _vm._e(), _c("div", { class: _vm.$style.container }, [!_vm.isMultiple ? _c("div", { class: _vm.$style.data }, [_c("span", { directives: [{ name: "show", rawName: "v-show", value: !_setup.isEditing, expression: "!isEditing" }], class: _vm.$style.content, attrs: { "data-testid": _setup.formatTestId("content") } }, [_vm._t("content")], 2), _c("fieldset", { directives: [{ name: "show", rawName: "v-show", value: _setup.isEditing, expression: "isEditing" }], class: _vm.$style.editor, attrs: { "disabled": _vm.isSending, "data-testid": _setup.formatTestId("editor") } }, [_vm._t("editor")], 2)]) : _vm._e(), _c("span", { class: _vm.$style.actions }, [_c(_setup.XButton, { directives: [{ name: "show", rawName: "v-show", value: !_setup.isEditing, expression: "!isEditing" }], class: _vm.$style.buttonEdit, attrs: { "border-radius": _setup.buttonRadius, "size": _setup.buttonSize, "design": _vm.isMultiple ? "outlined" : "text", "data-testid": _setup.formatTestId("buttonEdit"), "title": _setup.t("ds.xInlineEdit.actions.edit.title", { label: _vm.label }) }, on: { "click": _setup.handleEditor } }, [_vm.isMultiple ? _c("span", [_vm._v(" " + _vm._s(_setup.t("ds.global.actions.edit.base")) + " ")]) : _vm._e(), _c(_setup.XIcon, { attrs: { "icon": "pen", "right": _vm.isMultiple } })], 1), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _setup.isEditing, expression: "isEditing" }], class: _vm.$style.actionsEditor }, [_c(_setup.XButton, { class: _vm.$style.buttonCancel, attrs: { "border-radius": _setup.buttonRadius, "size": _setup.buttonSize, "design": "outlined", "disabled": _vm.isSending, "data-testid": _setup.formatTestId("buttonCancel"), "title": _setup.t("ds.xInlineEdit.actions.cancel.title", { label: _vm.label }) }, on: { "click": function($event) {
    return _setup.handleCancel();
  } } }, [_vm.isMultiple ? _c("span", { attrs: { "data-testid": _setup.formatTestId("buttonCancelText") } }, [_vm._v(" " + _vm._s(_setup.t("ds.global.actions.cancel.base")) + " ")]) : _c(_setup.XIcon, { attrs: { "icon": "close", "icon-style": "fak" } })], 1), _c(_setup.XButton, { class: _vm.$style.buttonSave, attrs: { "disabled": _vm.isInvalid, "loading": _vm.isSending, "border-radius": _setup.buttonRadius, "size": _setup.buttonSize, "design": "outlined", "data-testid": _setup.formatTestId("buttonSave"), "title": _setup.t("ds.xInlineEdit.actions.save.title", { label: _vm.label }) }, on: { "click": function($event) {
    return _setup.handleSave();
  } } }, [_vm.isMultiple ? _c("span", [_vm._v(" " + _vm._s(_setup.t("ds.global.actions.save.base")) + " ")]) : _vm._e(), _c(_setup.XIcon, { attrs: { "icon": "check", "right": _vm.isMultiple } })], 1)], 1)], 1)])]);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const XInlineEdit = __component__.exports;
export {
  XInlineEdit as default
};
